module.exports = {"component":"combobox","status":"prod","display-name":"Comboboxes","last-accessibility-review":{"date-iso-8601":"2017/08/21","commit-sha":"295a4766f712a5f93743c4ecd3ba62d91c1fc153"},"SLDS-component-path":"/components/combobox","url-slug":"comboboxes"}


//////////////////
// WEBPACK FOOTER
// ./components/combobox/docs.json
// module id = 174
// module chunks = 0